import { useTranslation } from "@ferrivia/i18n";
import { ArticleCard } from "./ArticleCard";
import type { ArticleSlot, ArticleSlotId } from "./articles";

function useArticleTitles(): Partial<Record<ArticleSlotId, string>> {
  const { t } = useTranslation("client");

  return {
    symptoms: t("summary.articles.symptoms", "Raudanpuutteen oireet"),
    menstruation: t("summary.articles.menstruation", "Kuukautiset ja rauta"),
    gut: t("summary.articles.gut", "Suoliston terveys ja raudan imeytyminen"),
    women_iron_needs: t("summary.articles.womenIronNeeds", "Kuinka paljon rautaa naiset todella tarvitsevat?"),
    postpartum: t(
      "summary.articles.postpartum",
      "Raudanpuute synnytyksen jälkeen: Mitä tuoreen äidin tulisi tietää",
    ),
    ferritin_fertility: t("summary.articles.ferritinFertility", "Alhainen ferritiini ja hedelmällisyys"),
  };
}

export function SlotArticle({ slot }: { slot: ArticleSlot }) {
  const titles = useArticleTitles();
  return <ArticleCard slotKind={slot.kind} title={titles[slot.id]} />;
}
